import { useCallback, useEffect, useRef } from "react";
import { useInvalidateMemberQueries } from "./useInvalidateMemberQueries";

type AppPaySessionRef = { start: boolean; end: boolean };

/**
 * App 内购支付会话：每次支付前 reset end；成功/失败/已有会员时标记 end；
 * 若支付已开始但未结束就卸载，延迟 invalidate（与 success 一致，等待后端落库）
 */
export const useAppPurchaseMemberInvalidate = () => {
  const appPayRef = useRef<AppPaySessionRef>({ start: false, end: false });
  const { invalidateMemberQueriesAfterDelay } = useInvalidateMemberQueries();

  const beginAppPurchase = useCallback(() => {
    appPayRef.current.start = true;
    appPayRef.current.end = false;
  }, []);

  const completeAppPurchase = useCallback(() => {
    appPayRef.current.end = true;
  }, []);

  useEffect(() => {
    return () => {
      if (appPayRef.current.start && !appPayRef.current.end) {
        void invalidateMemberQueriesAfterDelay();
      }
    };
  }, [invalidateMemberQueriesAfterDelay]);

  return {
    beginAppPurchase,
    completeAppPurchase,
    invalidateMemberQueriesAfterDelay,
  };
};
